// extracted by mini-css-extract-plugin
export default {"productGrid":"j2-z","centerLink":"k2-z","productSection":"l2-z","item":"m2-z","ctaButton":"n2-z"};